import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { replace } from 'react-router-redux';
import queryString from 'query-string';
import { connect } from 'react-redux';

import Field from 'src/ConnectedComponents/fields/Field';
import Logo from 'src/ConnectedComponents/utils/Logo';

import { getAuthUserById } from 'src/redux/authUsers/authUser.selector';
import { fetchAuthUser, requestUpdateAuthUser } from 'src/redux/authUsers/authUser.action';

import styles from './index.css';
import { FlexBox, HyperLink, ShadowBox, Text, Button } from 'src/lib/StyledComponents';

class ConfirmUser extends Component {
	componentDidMount() {
		this.props.fetchAuthUser(
			queryString.parse(this.props.location.search).user_id,
			{
				confirmation_code: queryString.parse(this.props.location.search).token,
			},
			true,
		);
	}

	render() {
		const { user, handleSubmit, error } = this.props;

		return (
			<form onSubmit={handleSubmit} className={styles.ConfirmUser}>
				<Logo />
				{user && user._id ? (
					<React.Fragment>
						<Text className={styles.Quote}>
							“A small group of thoughtful, committed citizens can change the world;
							indeed, it’s the only thing that ever has.”
							<br /> <strong>- Margaret Mead</strong>
						</Text>
						<ShadowBox className={styles.ConfirmUserPanel}>
							<Text className={styles.Title}>Welcome to Wisely!</Text>
							<Text className={styles.Subtitle}>
								Set your account password to proceed
							</Text>
							{error && <Text className={styles.Error}>{error}</Text>}
							<Field
								name="password"
								placeholder="Password"
								component="input"
								type="password"
								className={styles.Input}
							/>
							<FlexBox className={styles.ButtonContainer}>
								<Button type="submit" className={styles.SignInButton}>
									Continue
								</Button>
							</FlexBox>
						</ShadowBox>
					</React.Fragment>
				) : (
					<React.Fragment>
						<Text className={styles.ErrorText}>
							Sorry, that link doesn't match our records.
						</Text>
						<Text className={styles.ErrorTextBottom}>
							Need some help?{' '}
							<HyperLink href="mailto:hello@fundraisewisely.com">
								Contact us
							</HyperLink>
							!
						</Text>
					</React.Fragment>
				)}
			</form>
		);
	}
}

const onSubmit = async (user, _dispatch, props) => {
	const { user_id, token } = queryString.parse(props.location.search);
	const body = {
		confirmation_code: token,
		...user,
	};
	await props.requestUpdateAuthUser(user_id, body, true);
	props.replace('/login');
};

ConfirmUser = reduxForm({
	form: 'ConfirmUser',
	onSubmit,
})(ConfirmUser);

const mapStateToProps = (state, ownProps) => ({
	user: getAuthUserById(state, queryString.parse(ownProps.location.search).user_id),
});

const actions = {
	fetchAuthUser,
	replace,
	requestUpdateAuthUser,
};

ConfirmUser = connect(mapStateToProps, actions)(ConfirmUser);

export default ConfirmUser;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/ConfirmUser/index.js